<template>
  <div>
    <div class="flex-row flex-nowrap">
      <!--<div class="p-r-8 m-b-xs">
        <el-select
          clearable
          v-model="filter.province"
          filterable
          placeholder="——省份——"
          @change="handleChange($event, 'province')"
        >
          <el-option
            v-for="item in provinces"
            :key="item.areaCode"
            :label="item.areaName"
            :value="item.areaCode"
          ></el-option>
        </el-select>
      </div>
      <div class="p-r-8 m-b-xs">
        <el-select
          clearable
          v-model="filter.city"
          filterable
          placeholder="——城市——"
          @change="handleChange($event, 'city')"
        >
          <el-option
            v-for="item in cities"
            :key="item.areaCode"
            :label="item.areaName"
            :value="item.areaCode"
          ></el-option>
        </el-select>
      </div>-->
      <div class="p-r-8 m-b-xs">
        <el-cascader ref="filterCader" placeholder="所属区域" :props="policeStateProps" v-model="filter.pAreaCode" clearable @change="caderChange">
        </el-cascader>
      </div>
      <div class="p-r-8 m-b-xs">
        <el-input v-model="filter.areaName">
          <template #prepend>区域名称</template>
        </el-input>
      </div>
      <div class="p-r-8 m-b-xs page-search-block">
        <!-- <button type="button" @click="submitFilter" class="btn btn-info btn-sm">&nbsp;查询</button> -->
        <el-button size="small" type="primary" icon="Search" @click="submitFilter">查询</el-button>
        <!-- <i class="fa fa-random"></i> -->
      </div>
      <div class="flex-row flex-nowrap flex-block justify-content-end m-b-xs">
        <!-- <button type="button" data-toggle="modal" class="btn btn-sm btn-primary m-r-xs" href="#create-form" @click="handleCreate"><i class="fa fa-plus"></i>&nbsp;新增</button> -->
        <!-- <button type="button" class="btn btn-white btn-sm" @click="handleImportFile">导出</button> -->
        <!-- <RIcon
          title="新增"
          name="create"
          @on-select="handleCreate"
          data-toggle="modal"
          href="#create-form"
        />
        <RIcon title="导出" name="export" @on-select="handleImportFile" /> -->
        <el-button v-if="isShowBtn('add')" class="primary-btn-g m-r-xs" size="small" icon="Plus" name="create" data-toggle="modal" href="#create-form" @click="handleCreate">新增</el-button>
        <!--<el-button type="primary" :disabled="multipleSelection.length != 1" @click="handleEditRow">编辑</el-button>
        <el-button type="primary" :disabled="multipleSelection.length === 0" @click="handleDelete">删除</el-button>-->
        <!--<el-button v-if="isShowBtn('export')" class="primary-btn-g" icon="el-icon-download" name="export" @click="handleExport">导出</el-button>-->
      </div>
    </div>
    <!-- <hr /> -->
    <div class="table-responsive no-border">
      <el-table
        v-loading="loading"
        element-loading-spinner="el-icon-loading"
        :data="tableData"
        class="table table-stripped"
        stripe
        :height="height"
        @filter-change="filterChange"
        :row-key="updateRowKey"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="50" align="center"></el-table-column>
        <el-table-column
          v-for="(column, index) in tableColumn"
          :key="index"
          :prop="column.prop"
          :label="column.label"
          :sortable="column.sortable"
          :show-overflow-tooltip="true"
          :filter-multiple="false"
          :column-key="column.columnKey"
          :filters="column.filters"
          filter-placement="bottom"
          align="center"
        ></el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template #default="scope">
            <a
              v-if="updatePerm"
              class="btn text-gray btn-xs"
              data-toggle="modal"
              href="#create-form"
              @click="handleEdit(scope.$index, scope.row)"
            >
              <el-tooltip effect="dark" content="编辑" placement="top">
                <!-- <i class="fa fa-edit"></i> -->
                <span>编辑</span>
              </el-tooltip>
            </a>
            <!-- <span class="splitline">|</span> -->
            <el-popover v-if="deletePerm" placement="top">
              <slot>
                <div style="text-align: left; margin: 0">
                  <span :style="{'color': '@font-color-gray'}">确认删除吗?</span>
                  <br />
                  <br />
                  <el-button class="btn-cancel" size="small" @click="handleClosePopover($event)">取消</el-button>
                  <el-button
                    class="btn-primary"
                    size="small"
                    @click.prevent="handleDelete(scope.$index, scope.row)"
                  >确定</el-button>
                </div>
              </slot>
              <template #reference>
                <a style="padding: 1px 10px" type="text">删除</a>
              </template>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <Pagination
        class="r-pagination"
        :pageSize="pageSize"
        :total="recordTotal"
        :page="page"
        @current-change="handlePageChange"
      />
    </div>
    <Modal
      :modalTitle="clickModalType"
      modalId="create-form"
      @show="modalShow = true"
      @hide="modalShow = false"
      @close="modalShow = false"
      contentId="created-cnt"
    >
      <dictAreaForm
        :formType="clickModalType"
        :region="selectRegion"
        :modalShow="modalShow"
        @success="submitSuccess"
      />
    </Modal>
  </div>
</template>
<script>
import mixin from '@/components/common/tableMixin'
import { mapActions } from 'vuex'
import dictAreaForm from './dictAreaForm'

import dictCommonMixin from './common'

export default {
  name: 'dictArea',
  mixins: [mixin, dictCommonMixin],
  props: ['height'],
  components: {
    dictAreaForm
  },
  data() {
    return {
      pageSize: 20,
      recordTotal: 2,
      clickModalType: '新增',
      page: 1,
      provinces: [],
      cities: [],
      regions: [],
      filter: {
        city: '',
        province: '',
        areaName: '',
        pAreaCode: ''
      },
      selectRegion: null,
      loading: false,
      didInvalidate: false,
      modalShow: false,
      maxHeight: null,
      tableColumn: [
        {
          prop: 'areaName',
          label: '区域名称'
        },
        {
          prop: 'areaCode',
          label: '编码'
        },
        {
          prop: 'xpoint',
          label: '经度'
        },
        {
          prop: 'ypoint',
          label: '纬度'
        },
        {
          prop: 'use_status_text',
          label: '是否可用',
          columnKey: 'use_status',
          filters: [
            {
              text: '可用',
              value: '1'
            },
            {
              text: '不可用',
              value: '0'
            }
          ]
        }
      ],
      tableData: [],
      toExcel: false,
      multipleSelection:[],
      policeStateProps: {
        emitPath: false,
        lazy: true,
        checkStrictly: true,
        lazyLoad: this.getStateNext,
      },
    }
  },
  created() {
    let params = {
      areaCode: 0
    }
    let url = 'COMBOBOX.FIND_AREA_LIST_BY_PARENT_CODE'
    this._fetchBasicalData(url, params, 'provinces')
    //获取列表数据
    this.fetchDataIfNeeded({
      params: JSON.stringify({}),
      start: 0,
      size: this.pageSize,
      toExcel: this.toExcel
    })
  },
  mounted() {
    this.maxHeight = $('body').height() - $('.dictMng').offset().top - 165
  },
  watch: {
    'filter.province': function(to) {
      this.filter.city = ''
      let params = {
        areaCode: to
      }
      let url = 'COMBOBOX.FIND_AREA_LIST_BY_PARENT_CODE'
      this._fetchBasicalData(url, params, 'cities')
    }
  },
  methods: {
    _fetch(params) {
      this._requestData()
      let url = 'DICT.AREA_INFO_LIST'
      const _this = this
      this.fetchData({
        url,
        method: 'get',
        params
      })
        .then(res => {
          _this._receiveData()
          if (params.toExcel) {
            this.toExcel = false
            window.location.href = res.data
            return
          }
          _this.recordTotal = res.count
          _this.tableData = _this._getter(res.data) || []
        })
        .catch(err => {
          _this._receiveData()
          _this.error = err
        })
    },
    _getter(items) {
      return items.map((data, index) => {
        data['use_status_text'] = data['use_status'] === '1' ? '可用' : '不可用'
        Object.keys(data).forEach(function(key) {
          if (data[key] === null) {
            data[key] = ''
          }
        })
        return data
      })
    },
    _fetchBasicalData(url, params, type) {
      const _this = this
      this.fetchData({ url, method: 'get', params })
        .then(res => {
          this[type] = res.data
        })
        .catch(err => {
          this.error = err
        })
    },
    _reloadData() {
      /*this.filter.pAreaCode = this.filter.city ? this.filter.city : this.filter.province
      if (!this.filter.province) {
        this.filter.pAreaCode = this.filter.city = ''
      }*/
      let params = {
        params: JSON.stringify(this.filter),
        start: (this.page - 1) * this.pageSize,
        size: this.pageSize,
        toExcel: this.toExcel
      }
      if(this.toExcel && this.multipleSelection.length){
        params.params = JSON.stringify({ids:this.multipleSelection.map(item => item.id).join(',')})
      }
      //强制请求数据
      this.refreshData()
      this.fetchDataIfNeeded(params)
    },
    // 分页
    handlePageChange(val, ops) {
      this.page = val
      this.pageSize = ops
      this._reloadData()
    },
    filterChange(filters) {
      if (filters.use_status !== undefined) {
        this._filterStatus(filters.use_status[0])
      }
    },
    _filterStatus(value) {
      this.filter['use_status'] = value
      this.submitFilter()
    },
    //级联选中
    caderChange(){
      this.$refs.filterCader.dropDownVisible = false
    },
    // 省市区,树形结构
    getStateNext(node, resolve) {
      if(node.level==4){
        resolve([])
      }
      let code = node.level == 0 ? 0 : node.value

      let url = 'COMBOBOX.FIND_AREA_LIST_BY_PARENT_CODE'

      let params = {
        areaCode: code,
      }
      this.fetchData({
        url,
        method: 'get',
        params,
      })
        .then((res) => {
          let tempArr = []
          res.data.forEach((re) => {
            if (re.areaName) {
              tempArr.push({
                value: re.areaCode,
                label: re.areaName,
                leaf: node && node.level == 3 ? true : false,
              })
            }
            if (re.name) {
              tempArr.push({
                value: re.policeCode,
                label: re.name,
                leaf: node && node.level == 3 ? true : false,
              })
            }
          })
          resolve(tempArr)
        })
    },
    handleCreate() {
      this.clickModalType = '新增'
      this.selectRegion = null
    },
    handleEdit(index, row) {
      this.clickModalType = '编辑'
      this.selectRegion = row
    },
    submitSuccess(params) {
      this.filter.province = params.province
      setTimeout(() => {
        this.filter.city = params.city
        this.submitFilter()
      }, 100)
      $('#create-form').modal('hide')
    },
    handleDelete(index, row) {
      let url = 'DICT.AREA_INFO_DELETE'
      let params = {
        id: row.id
      }
      this.fetchData({
        url,
        method: 'post',
        params,
        timeout:0,
        isLoading:false,
        flag:true
      })
        .then(res => {
          if(res && res.status==1){
            this.alertToggle({
              alertType: 'success',
              alertContent: res.msg||'删除成功！'
            })
            this._reloadData()
          }else{
            let tipMsg = (res && res.msg) ? res.msg:'操作失败'
            this.alertToggle({
              alertType: 'danger',
              alertContent: tipMsg
            })
          }
        })
        .catch(err => {
          this.alertToggle({
            alertType: 'danger',
            alertContent: err
          })
        })
      $('body').trigger('click')
    },
    handleChange(val, ops) {
      this.filter[ops] = val
      this.submitFilter()
    },
    handleImportFile() {
      this.toExcel = true
      this._reloadData()
    },
    handleExport(){
      this.toExcel = true
      this._reloadData()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
  }
}
</script>
<style lang="less">

</style>
